const AbstractItemRepository = require('@/lib/Items/AbstractItemRepository');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const Product = require('./Product');

class ProductRepository extends AbstractItemRepository {
    /**
     * @param {DataStore} dataStore
     * @param {Hydrator} hydrator
     * @param {SyncStateManager} syncStateManager
     * @param {ItemBarcodeRepository} itemBarcodeRepository
     * @param productResource
     */
    constructor(
        dataStore,
        hydrator,
        syncStateManager,
        itemBarcodeRepository,
        productResource
    ) {
        super(dataStore, hydrator, syncStateManager, itemBarcodeRepository);

        this.productResource = productResource;
    }

    getEntityClass() {
        return Product;
    }

    getEntityName() {
        return 'Product';
    }

    getTableName() {
        return DataStoreNames.PRODUCTS;
    }

    getResource() {
        return this.productResource;
    }
}

module.exports = ProductRepository;
